export default __webpack_public_path__ + "static/media/avatar.b067fa28.jpeg";